var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardingExploremarketplace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-398.885 -212.885)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(398.885 212.885)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.734 271.522h-20.668a.191.191 0 01-.191-.191v-27.715a.19.19 0 01.058-.137l10.334-10a.19.19 0 01.265 0l10.334 10a.192.192 0 01.058.137v27.715a.191.191 0 01-.19.191zm-20.477-.381h20.287v-27.445l-10.143-9.815-10.144 9.815z",
    fill: "#0e5b7c"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0e5b7c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.196 254.164a5.715 5.715 0 012.934.811 5.744 5.744 0 0111.109.174 5.727 5.727 0 016.1.737 5.747 5.747 0 0110.286-.442 5.747 5.747 0 11-2.026 7.671 5.731 5.731 0 01-6.646-.442 5.744 5.744 0 01-10.828-.957 5.7 5.7 0 01-5.4-.249 5.748 5.748 0 11-5.533-7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.637 266.279a5.945 5.945 0 01-5.1-2.9 5.921 5.921 0 01-6.507-.407 5.935 5.935 0 01-11.025-.987 5.947 5.947 0 01-5.16-.233 5.947 5.947 0 11-2.825-7.059 5.934 5.934 0 0111.349.191 6 6 0 015.907.706 5.937 5.937 0 0110.425-.407 5.939 5.939 0 112.94 11.1zm-5.035-3.354a.191.191 0 01.048.006.193.193 0 01.119.092 5.567 5.567 0 101.959-7.416.191.191 0 01-.267-.07 5.556 5.556 0 00-9.944.427.191.191 0 01-.295.07 5.569 5.569 0 00-3.517-1.255 5.5 5.5 0 00-2.384.543.191.191 0 01-.267-.127 5.553 5.553 0 00-10.741-.168.191.191 0 01-.281.113 5.557 5.557 0 102.513 6.277.19.19 0 01.281-.113 5.568 5.568 0 005.22.241.189.189 0 01.164 0 .191.191 0 01.1.127 5.554 5.554 0 0010.469.924.191.191 0 01.295-.07 5.54 5.54 0 006.426.427.192.192 0 01.103-.029z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M463.732 271.522h-50.216a.19.19 0 01-.191-.191V243.64a.191.191 0 11.381 0v27.5h49.835v-27.5a.191.191 0 01.381 0v27.692a.191.191 0 01-.19.19z",
    fill: "#0e5b7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.309 243.615c0 2.316 1.317 4.19 2.941 4.19s2.937-1.874 2.937-4.19z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.25 247.996c-1.727 0-3.132-1.965-3.132-4.38a.19.19 0 01.191-.191h5.878a.19.19 0 01.191.191c-.001 2.415-1.404 4.38-3.128 4.38zm-2.747-4.19c.069 2.117 1.275 3.808 2.747 3.808s2.675-1.692 2.744-3.808z",
    fill: "#0e5b7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.434 243.615c0 2.316 1.314 4.19 2.937 4.19s2.938-1.874 2.938-4.19z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.37 247.996c-1.725 0-3.128-1.965-3.128-4.38a.19.19 0 01.191-.191h5.875a.19.19 0 01.191.191c0 2.415-1.404 4.38-3.129 4.38zm-2.744-4.19c.069 2.117 1.273 3.808 2.744 3.808s2.675-1.692 2.744-3.808z",
    fill: "#0e5b7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.556 243.615c0 2.316 1.314 4.19 2.938 4.19s2.941-1.874 2.941-4.19z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.493 247.996c-1.725 0-3.128-1.965-3.128-4.38a.19.19 0 01.191-.191h5.878a.191.191 0 01.191.191c0 2.415-1.405 4.38-3.132 4.38zm-2.744-4.19c.069 2.117 1.273 3.808 2.744 3.808s2.678-1.692 2.747-3.808z",
    fill: "#0e5b7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.678 243.615c0 2.316 1.314 4.19 2.938 4.19s2.941-1.874 2.941-4.19z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.615 247.996c-1.725 0-3.128-1.965-3.128-4.38a.19.19 0 01.191-.191h5.878a.19.19 0 01.191.191c-.001 2.415-1.405 4.38-3.132 4.38zm-2.744-4.19c.069 2.117 1.273 3.808 2.744 3.808s2.678-1.692 2.747-3.808z",
    fill: "#0e5b7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.429 243.615h5.813l10.332-10h-5.813z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.241 243.807h-5.813a.191.191 0 01-.132-.328l10.332-10a.19.19 0 01.133-.054h5.813a.191.191 0 01.133.328l-10.333 10a.191.191 0 01-.133.054zm-5.342-.381h5.265l9.938-9.619h-5.265z",
    fill: "#0e5b7c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M425.616 243.615h5.813l10.332-10h-5.813z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.428 243.807h-5.813a.191.191 0 01-.133-.328l10.332-10a.191.191 0 01.133-.054h5.813a.191.191 0 01.133.328l-10.333 10a.191.191 0 01-.132.054zm-5.342-.381h5.265l9.939-9.619h-5.265z",
    fill: "#0e5b7c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M419.48 243.615h6.136l10.332-10h-6.136z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.615 243.807h-6.136a.191.191 0 01-.132-.328l10.332-10a.191.191 0 01.133-.054h6.136a.191.191 0 01.132.328l-10.332 10a.191.191 0 01-.133.054zm-5.664-.381h5.588l9.938-9.619h-5.588z",
    fill: "#0e5b7c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413.516 243.615h5.964l10.332-10h-5.919z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.48 243.807h-5.964a.191.191 0 01-.132-.328l10.377-10a.19.19 0 01.132-.054h5.92a.191.191 0 01.133.328l-10.332 10a.191.191 0 01-.134.054zm-5.492-.381h5.415l9.938-9.619h-5.37z",
    fill: "#0e5b7c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M463.733 258.488v12.844h-50.217v-12.844z",
    fill: "#fbc282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.732 271.526h-50.216a.19.19 0 01-.191-.191v-12.847a.19.19 0 01.191-.191h50.217a.19.19 0 01.191.191v12.844a.191.191 0 01-.192.194zm-50.026-.381h49.835v-12.467h-49.835z",
    fill: "#0e5b7c"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0e5b7c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.732 262.648h-50.216a.191.191 0 010-.381h50.217a.191.191 0 110 .381zM463.732 267.552h-50.216a.191.191 0 010-.381h50.217a.191.191 0 110 .381z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M434.184 271.522h-20.668a.19.19 0 01-.191-.191v-27.715a.189.189 0 01.058-.137l10.334-10a.19.19 0 01.265 0l10.334 10a.19.19 0 01.058.137v27.715a.191.191 0 01-.19.191zm-20.477-.381h20.287v-27.445l-10.143-9.815-10.145 9.815z",
    fill: "#0e5b7c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M440.062 243.615c0 2.316-1.317 4.19-2.94 4.19s-2.938-1.874-2.938-4.19z",
    fill: "#6e9db0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.121 247.996c-1.725 0-3.128-1.965-3.128-4.38a.19.19 0 01.191-.191h5.878a.191.191 0 01.191.191c-.001 2.415-1.406 4.38-3.132 4.38zm-2.744-4.19c.068 2.117 1.273 3.808 2.744 3.808s2.678-1.692 2.747-3.808z",
    fill: "#0e5b7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.94 243.615c0 2.316-1.318 4.19-2.941 4.19s-2.938-1.874-2.938-4.19z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.999 247.996c-1.725 0-3.128-1.965-3.128-4.38a.191.191 0 01.191-.191h5.878a.19.19 0 01.191.191c0 2.415-1.405 4.38-3.132 4.38zm-2.744-4.19c.068 2.117 1.273 3.808 2.744 3.808s2.678-1.692 2.747-3.808z",
    fill: "#0e5b7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.815 243.615c0 2.316-1.314 4.19-2.938 4.19s-2.937-1.874-2.937-4.19z",
    fill: "#6e9db0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.878 247.996c-1.724 0-3.128-1.965-3.128-4.38a.19.19 0 01.191-.191h5.875a.19.19 0 01.191.191c-.001 2.415-1.404 4.38-3.129 4.38zm-2.744-4.19c.068 2.117 1.273 3.808 2.744 3.808s2.676-1.692 2.744-3.808z",
    fill: "#0e5b7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.693 243.615c0 2.316-1.313 4.19-2.937 4.19s-2.941-1.874-2.941-4.19z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.755 247.996c-1.726 0-3.131-1.965-3.131-4.38a.19.19 0 01.191-.191h5.878a.19.19 0 01.191.191c-.001 2.415-1.404 4.38-3.129 4.38zm-2.747-4.19c.069 2.117 1.274 3.808 2.747 3.808s2.676-1.692 2.744-3.808z",
    fill: "#0e5b7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.571 243.615c0 2.316-1.314 4.19-2.937 4.19s-2.941-1.874-2.941-4.19z",
    fill: "#6e9db0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.633 247.996c-1.727 0-3.132-1.965-3.132-4.38a.191.191 0 01.191-.191h5.878a.19.19 0 01.191.191c0 2.415-1.403 4.38-3.128 4.38zm-2.747-4.19c.069 2.117 1.275 3.808 2.747 3.808s2.675-1.692 2.744-3.808z",
    fill: "#0e5b7c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M440.007 243.615h-5.823l-10.332-10h5.823z",
    fill: "#6e9db0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.003 243.807h-5.823a.191.191 0 01-.133-.054l-10.332-10a.191.191 0 01.133-.328h5.823a.191.191 0 01.132.054l10.333 10a.191.191 0 01-.133.328zm-5.746-.381h5.275l-9.939-9.619h-5.275z",
    fill: "#0e5b7c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M445.819 243.615h-5.813l-10.332-10h5.813z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.819 243.807h-5.813a.19.19 0 01-.132-.054l-10.333-10a.191.191 0 01.133-.328h5.813a.189.189 0 01.132.054l10.332 10a.191.191 0 01-.132.328zm-5.736-.381h5.265l-9.938-9.619h-5.265z",
    fill: "#0e5b7c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M451.632 243.615h-5.815l-10.332-10h5.813z",
    fill: "#6e9db0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.632 243.807h-5.813a.192.192 0 01-.133-.054l-10.332-10a.191.191 0 01.133-.328h5.813a.191.191 0 01.133.054l10.332 10a.191.191 0 01-.132.328zm-5.736-.381h5.265l-9.935-9.62h-5.264z",
    fill: "#0e5b7c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M457.769 243.615h-6.136l-10.332-10h6.136z",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.768 243.807h-6.136a.191.191 0 01-.133-.054l-10.333-10a.191.191 0 01.133-.328h6.136a.19.19 0 01.132.054l10.329 9.997a.191.191 0 01-.133.328zm-6.059-.381h5.588l-9.938-9.619h-5.588z",
    fill: "#0e5b7c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M463.733 243.615h-5.964l-10.332-10h5.919z",
    fill: "#6e9db0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.733 243.807h-5.964a.19.19 0 01-.132-.054l-10.333-10a.191.191 0 01.133-.328h5.919a.191.191 0 01.133.054l10.377 10a.191.191 0 01-.132.328zm-5.887-.381h5.414l-9.982-9.619h-5.371z",
    fill: "#0e5b7c"
  }))))));
}
export default SvgOnboardingExploremarketplace;